<script lang="ts">
  import * as _ from 'lodash';
  import type { SellSheetRetailerUser } from '@shared/types/User'
  import { convertToFormattedLocaleDate } from '@shared/svelte/Components/DateFormatter/LocaleString.svelte';

  export let retailerUser: SellSheetRetailerUser;
  export let selectedRetailersIds: number[];
  export let retailerName: (ru:any) => void;
  export let clickRetailerDiv: (ru: SellSheetRetailerUser) => void;
  export let highlight: (value: any) => void;
  export let phoneFormat: (phoneNumber: number) => void;
  export let sellSheetId: number;
  export let responsiveLayout: boolean = false;

  let sellSheetShares = retailerUser.user.shared_with_user_sell_sheet_shares?.filter(share => {
    return share.sell_sheet_id == sellSheetId
  })
  let hasSellSheetShares = sellSheetShares.length > 0;
  let isSelected = selectedRetailersIds?.includes(retailerUser.id);
  $: isChecked = hasSellSheetShares || isSelected;
</script>

<style>
  .gray-800 {
    color: #1B1B1B;
  }
  .gray-500 {
    color: #848484;
  }
</style>

<div class="fizz-align-content-start fizz-flex-row-8 fizz-inset-square-16 fizz-bordered fizz-stack-8"
  class:fizz-inset-square-16={!responsiveLayout} class:fizz-inset-square-8={responsiveLayout}
  style={hasSellSheetShares ? 'pointer-events:none' : ''} on:click={() => clickRetailerDiv(retailerUser)}>
  <input
    type="checkbox"
    class="fizz-checkbox"
    id="retailer-user-{retailerUser.user.id}"
    style="margin-top: 0.15rem;"
    bind:value={retailerUser.id}
    bind:group={selectedRetailersIds}
    bind:checked={isChecked}
    disabled={hasSellSheetShares}
  />
  <div class="fizz-flex-item">
    <h4 class="gray-800">{@html highlight(retailerName(retailerUser.user))}</h4>
    <h4 class="gray-500">
      {@html highlight(retailerUser.retailer.name)}
    </h4>
    <h4 class="gray-500" class:fizz-stack-4={hasSellSheetShares}>
      {@html highlight(phoneFormat(retailerUser.user.phone))} 
      {#if retailerUser.user.phone && retailerUser.user.email && !responsiveLayout} • {/if}
      {@html highlight(retailerUser.user.email)}
    </h4>
    {#if hasSellSheetShares}
      <span>Previously shared on
        {convertToFormattedLocaleDate(retailerUser.user.shared_with_user_sell_sheet_shares[0].created_at)}
      </span>
    {/if}
  </div>
</div>


